import { EVENT_PUBLIC_URL_SCHEME } from "@shared/schemas/storage-file.schemas";

function getPublicAssetBaseUrl(): string {
  // eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- Vite environment variables are external build input
  const envUrl: unknown = import.meta.env["VITE_PUBLIC_ASSET_BASE_URL"];
  return typeof envUrl === "string" ? envUrl.replace(/\/+$/, "") : "";
}

export function resolvePublicAssetUrl(
  url: string | null | undefined,
): string | null | undefined {
  if (url == null || !url.startsWith(EVENT_PUBLIC_URL_SCHEME)) {
    return url;
  }

  const path = url.slice(EVENT_PUBLIC_URL_SCHEME.length).replace(/^\/+/, "");
  return `${getPublicAssetBaseUrl()}/${path}`;
}
